<script setup lang="ts">
import ListGroup from "@/components/ui/ComplexList/ListGroup.vue";
import ListGroupHeader from "@/components/ui/ComplexList/ListGroupHeader.vue";
import ListHeaderContent from "@/components/ui/ComplexList/ListHeaderContent.vue";
import type { ResolvedCard } from "@/model/card";
import type { SearchResultKey } from "@/model/search";

import SearchResultList from "./SearchResultList.vue";
import {
  groupResultsByDependencyTeamFilter,
  groupResultsByTypeOrTeam,
  showDependencyGroupingHeader,
} from "./groupSearchResults";

defineProps<{ items: ResolvedCard[]; boardId: string; selected?: SearchResultKey }>();

const emit = defineEmits<{ select: [item: SearchResultKey] }>();
</script>

<template>
  <ListGroup v-for="(chunk, type) in groupResultsByTypeOrTeam(items)" :key="type">
    <template #header>
      <ListGroupHeader>
        <ListHeaderContent :text="type" />
        <template #after>{{ chunk.length }}</template>
      </ListGroupHeader>
    </template>

    <ListGroup v-for="(results, title) in groupResultsByDependencyTeamFilter(chunk)" :key="title">
      <template v-if="showDependencyGroupingHeader(results)" #header>
        <ListGroupHeader class="dependency-grouping-header">
          <ListHeaderContent sub :text="$t(title)" />
        </ListGroupHeader>
      </template>

      <SearchResultList :results :selected :board-id @select="emit('select', $event)" />
    </ListGroup>
  </ListGroup>
</template>

<style lang="scss" scoped>
.dependency-grouping-header {
  padding-top: 0;
}
</style>
